import { TooltipComponent } from '@components/core/tooltip.component';
import { Badge } from '@components/ui/badge';
import { Button } from '@components/ui/button';
import { cn } from '@lib/utils';

type ShortcutBadgeProps = {
  className?: string;
  shortcut: string;
  tooltipText?: string;
};

export const ShortcutBadge: React.FC<ShortcutBadgeProps> = (props) => {
  const { className, shortcut, tooltipText } = props;

  return (
    <TooltipComponent
      side="top"
      trigger={
        <Badge
          className={cn('text-current', className)}
          size="xs"
          variant="outline"
        >
          {shortcut}
        </Badge>
      }
    >
      {tooltipText ?? `Press ${shortcut} to select this option`}
    </TooltipComponent>
  );
};

type NavigationButtonsProps = {
  isNextLoading?: boolean;
  isPreviousLoading?: boolean;
  onNext: () => void;
  onPrevious: () => void;
  previousQuestion?: boolean;
};

export const NavigationButtons: React.FC<NavigationButtonsProps> = (props) => {
  const { isNextLoading, isPreviousLoading, onNext, onPrevious, previousQuestion } = props;

  return (
    <div className="@container/navigation flex w-full flex-col pt-4 @min-[26rem]/navigation:flex-row @min-[26rem]/navigation:justify-end">
      <div className="flex flex-col items-stretch gap-3 @min-[26rem]/navigation:flex-row @min-[26rem]/navigation:items-center @min-[26rem]/navigation:gap-4">
        <div className="w-full @min-[26rem]/navigation:w-[140px]">
          <Button
            className="w-full"
            disabled={!previousQuestion || isPreviousLoading || isNextLoading}
            onClick={onPrevious}
            variant="secondary"
          >
            <span className="flex items-center justify-center gap-2">
              Previous
              <ShortcutBadge
                className="border-gray-400 text-gray-500 underline"
                shortcut="←"
                tooltipText="Press ← (Left Arrow) to go to previous question"
              />
            </span>
          </Button>
        </div>
        <div className="w-full @min-[26rem]/navigation:w-[140px]">
          <Button
            className="w-full"
            disabled={isNextLoading || isPreviousLoading}
            onClick={onNext}
            variant="primary"
          >
            <span className="flex items-center justify-center gap-2">
              Next
              <ShortcutBadge
                className="underline"
                shortcut="→"
                tooltipText="Press → (Right Arrow) to go to next question"
              />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};
